module.exports = __webpack_public_path__ + "static/media/chateaux-jardins.5732726d.webp";